// only one activity for user in group
import { action, computed, observable, values, makeObservable } from 'mobx';

import { IUserTypingMessageEvent } from 'APP/model/group/groupModel.types';

const REMOVE_AFTER_MS = 4000;

interface IUserTypingDataItem {
  payload: IUserTypingMessageEvent;
  timerId: ReturnType<typeof setTimeout>;
  ts: number;
}

export class UserTyping {
  @observable data = observable.map<string, IUserTypingDataItem>({}, { deep: false });

  constructor() {
    makeObservable(this);
  }

  @action
  add(payload: IUserTypingMessageEvent): void {
    const { userId } = payload;

    const timerId = setTimeout(() => {
      this.remove(userId);
    }, REMOVE_AFTER_MS);

    clearTimeout(this.data.get(userId)?.timerId);

    this.data.set(userId, {
      payload,
      timerId: timerId,
      ts: Date.now(),
    });
  }

  @action
  remove(userId: string): void {
    clearTimeout(this.data.get(userId)?.timerId);
    this.data.delete(userId);
  }

  @computed
  get events(): IUserTypingMessageEvent[] {
    return values(this.data).map(({ payload }) => {
      return { ...payload };
    });
  }
}
